export default {
    formId: 'contratoForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre del contrato',
            requiredErrorMsg: 'El nombre es requerido'
        },
        typeContract: {
            name: 'typeContract',
            label: 'Tipo de contrato',
            requiredErrorMsg: 'El tipo de contrato es requerido'
        },
        content: {
            name: 'content',
            label: 'Contenido del contrato',
            requiredErrorMsg: 'El contenido es requerido'
        }
    }
};
